import React, {
  PropsWithChildren,
  useCallback,
  useMemo,
  useState,
} from "react";

import { useCheckUserActivity } from "@is/hooks";

export type UserActivityContextValue = {
  showUserActivityModal: boolean;
  showStyleNotExistModal: boolean;
  userActivityModalExpiredTime: number;
  styleNotExistModalExpiredTime: number;
  startStyleNotExistProgressBar: boolean;
  setShowUserActivityModal: (value: boolean) => void;
  setUserActivityModalExpiredTime: (value: number) => void;
  setStartStyleNotExistProgressBar: (value: boolean) => void;
  setStyleNotExistModalExpiredTime: (value: number) => void;
  setShowStyleNotExistModal: (value: boolean) => void;
  resetStyleNotExistValues: () => void;
} | null;

export const UserActivityContext =
  React.createContext<UserActivityContextValue>(null);

export const UserActivityProvider = ({ children }: PropsWithChildren) => {
  const [showUserActivityModal, setShowUserActivityModal] =
    useState<boolean>(false);
  const [showStyleNotExistModal, setShowStyleNotExistModal] =
    useState<boolean>(false);
  const [userActivityModalExpiredTime, setUserActivityModalExpiredTime] =
    useState<number>(Date.now());
  const [styleNotExistModalExpiredTime, setStyleNotExistModalExpiredTime] =
    useState<number>(Date.now());
  const [startStyleNotExistProgressBar, setStartStyleNotExistProgressBar] =
    useState<boolean>(false);

  const resetStyleNotExistValues = useCallback(() => {
    setShowStyleNotExistModal(false);
    setStartStyleNotExistProgressBar(false);
    setStyleNotExistModalExpiredTime(Date.now());
  }, [
    setShowStyleNotExistModal,
    setStartStyleNotExistProgressBar,
    setStyleNotExistModalExpiredTime,
  ]);

  const contextValue: UserActivityContextValue = useMemo(
    () => ({
      showUserActivityModal,
      showStyleNotExistModal,
      userActivityModalExpiredTime,
      styleNotExistModalExpiredTime,
      startStyleNotExistProgressBar,
      setShowUserActivityModal,
      setUserActivityModalExpiredTime,
      setStartStyleNotExistProgressBar,
      setStyleNotExistModalExpiredTime,
      setShowStyleNotExistModal,
      resetStyleNotExistValues,
    }),
    [
      userActivityModalExpiredTime,
      showStyleNotExistModal,
      showUserActivityModal,
      startStyleNotExistProgressBar,
      styleNotExistModalExpiredTime,
      setStartStyleNotExistProgressBar,
      setStyleNotExistModalExpiredTime,
      setShowStyleNotExistModal,
      resetStyleNotExistValues,
    ]
  );

  useCheckUserActivity({
    expiredTime: userActivityModalExpiredTime,
    setExpiredTime: setUserActivityModalExpiredTime,
    setShowUserActivityModal,
  });

  // useStyleNotExist({
  //   showStyleNotExistModal,
  //   setStartStyleNotExistProgressBar,
  //   setStyleNotExistModalExpiredTime,
  //   setShowStyleNotExistModal,
  //   expiredTime: styleNotExistModalExpiredTime,
  //   resetStyleNotExistValues,
  // });

  return (
    <UserActivityContext.Provider value={contextValue}>
      {children}
    </UserActivityContext.Provider>
  );
};
